import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { DropzoneArea } from 'material-ui-dropzone';
import CloseIcon from '@material-ui/icons/Close';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Tooltip } from '@material-ui/core';
import { globalPutService, globalPostService, globalGetService, globalExportService, globalDeleteService } from '../../../utils/globalApiServices';
import { checkApiStatus, downloadFileType } from '../../../utils';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { DeletePopUp, PageLoader } from '../../../shared_elements';
import { trackActivity } from '../../../utils/mixpanel';
import { templateObj } from '.';
import { permissionCheckFnforCamo } from '../../../utils';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
const TemplateCRU = ({ tempData, modalCloseFn, getResponseBack, modeType, getTempDelFileRes }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(tempData ? tempData : templateObj);
    const [error, setError] = useState({});
    const [egineFamily, setEngineFamily] = useState([])
    const [deleteTempFile, setDeleteTempFile] = useState({ modal: false, data: null })
    const [previewFile, setPreviewFile] = useState({ modal: false, data: null, singlepreview: null, mode: '' })
   
    useEffect(() => {
        getEngineFamily()
    }, [])

    const onFieldChange = (key, value) => {
        const updateData = { ...data, [key]: value }
        setData(updateData);
            if ((tempData?.section_id?.id !== updateData?.section_id?.id || tempData?.engine_family?.id !== updateData?.engine_family?.id) && data?.id && tempData?.file_path && (key === "engine_family" || key === "section_id")) {
                globalDeleteService(`camo/template/file_delete/${data?.id}/`)
                    .then((response) => {
                        getResponseBack()
                        getTempDelFileRes(updateData)
                        if (checkApiStatus(response)) {
                            trackActivity('Template File Deleted Success via OnChange - Airworthiness Management', {
                                event_type: 'Templates File Delete',
                                page_title: 'Templates Deleted Success',
                                deleted_id: deleteTempFile?.data?.id,
                                success_msg: response?.data?.message
                            })
                        } else {
                            trackActivity('Template File Deleted Failed via OnChange - Airworthiness Management', {
                                event_type: 'Templates  Delete ',
                                page_title: 'Templates Delete Failed ',
                                deleted_id: deleteTempFile?.data?.id,
                                error_msg: response?.data?.message
                            })
                        }
                    })
            }
    }

    const templateDownload = () => {
        setLoading(true)
        globalExportService(`camo/template/blank_sample/${data?.engine_family?.id}/${data?.section_id?.id}/`)
            .then(response => {
                downloadFileType(response?.data, data?.section_id?.name + '_Sample_Template', 'xlsx');
                trackActivity('Sample Template Download - Airworthiness Management', {
                    event_type: 'Item Exported',
                    page_title: 'Templates',
                    file_extension: 'xlsx',
                    file_name: data?.section_id?.name + '_Sample_Template'
                });
                setLoading(false)
            })
    }

    const getEngineFamily = () => {
        globalGetService(`camo/engine_dropdown/?active=true`)
            .then((response) => {
                if (checkApiStatus(response)) {
                    setEngineFamily(response?.data?.data?.engine_family)
                }
            })
    }
    const handleChipClick = (event, id) => {
        setLoading(true);
        if (event?.endsWith('.xlsx')) {
            if (id) {
                setLoading(false);
                setPreviewFile({ modal: true, data: null, singlepreview: false, mode: id })
            } else {
                let formData = new FormData();
                formData.append('file', data?.file?.find(item => item?.path === event));
                globalPostService(`camo/preview/file/`, formData)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            setLoading(false);
                            setPreviewFile({ modal: true, data: response?.data, singlepreview: false, mode: null })
                        }
                    });
            }
        } else {
            setLoading(false);
            // setPreviewFile({ modal: true, data: [data?.file.find(item => item?.path === event)], singlepreview: true })
        }
    };

    const onAddEditTemp = () => {
        let validationInputs = {};
        validationInputs = {
            engine_family: data?.engine_family?.name ? '' : 'Please select engine family',
            section_id: data?.section_id?.id ? '' : 'Please select section',
        }
        var formData = new FormData();
        if (data?.id) {
            if (data?.file?.length) {
                for (let i = 0; i < data?.file.length; i++) {
                    let file = data?.file[i];
                    formData.append('file', file);
                }
            } else {
                formData.append('file_path', tempData?.file_path || null);
                formData.append('file_name', tempData?.file_name || null);
            }
        } else {
            for (let i = 0; i < data?.file.length; i++) {
                let file = data?.file[i];
                formData.append('file', file);
            }
        }
        formData.append('engine_family', data?.engine_family?.id || null);
        formData.append('section_id', data?.section_id?.id || ''); //
        formData.append('remarks', data?.remarks || '');
        formData.append('active', data?.active || false);

        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            if (data?.id) {
                globalPutService(`camo/template/sample/${data?.id}/`, formData)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            modalCloseFn();
                            getResponseBack();
                            trackActivity('Airworthiness Management', {
                                event_type: 'Template update Flow',
                                page_title: 'Template Data updated Successfully',
                                updated_id: response?.data?.id,
                                success_msg: response?.data?.message
                            })
                        } else {
                            enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            setLoading(false);
                            trackActivity('Airworthiness Management', {
                                event_type: 'Template update Flow',
                                page_title: 'Template Data updated Successfully',
                                updated_id: response?.data?.id,
                                error_msg: response?.data?.message
                            })

                        }
                    })
            } else {
                globalPostService(`camo/template/sample/`, formData)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            modalCloseFn();
                            getResponseBack();
                            trackActivity('Airworthiness Management', {
                                event_type: 'Template Add Flow',
                                page_title: 'Template Data added Successfully',
                                added_id: response?.data?.id,
                                success_msg: response?.data?.message
                            })
                        } else {
                            enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            setLoading(false);
                            trackActivity('Airworthiness Management', {
                                event_type: 'Template Add Flow',
                                page_title: 'Template Data added failed',
                                error_msg: response?.data?.message
                            })
                        }
                    })
            }
        } else {
            setError(validationInputs)
        }
    }
    const deleteTemplateFile = () => {
        setLoading(true)
        globalDeleteService(`camo/template/file_delete/${deleteTempFile?.data?.id}/`)
            .then((response) => {
                getResponseBack();
                setLoading(false);
                setDeleteTempFile({ modal: false, data: null })
                getTempDelFileRes(deleteTempFile?.data)
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity('Template File Deleted Success - Airworthiness Management', {
                        event_type: 'Templates File Delete',
                        page_title: 'Templates Deleted Success',
                        deleted_id: deleteTempFile?.data?.id,
                        success_msg: response?.data?.message
                    })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    trackActivity('Template File Deleted Failed - Airworthiness Management', {
                        event_type: 'Templates  Delete ',
                        page_title: 'Templates Delete Failed ',
                        deleted_id: deleteTempFile?.data?.id,
                        error_msg: response?.data?.message
                    })
                }

            })
    }
    return (
        <>
            <Dialog
                open={true}
                className='fleet-template-modal'
                maxWidth='sm'
            >
                <DialogTitle id="scroll-dialog-title">
                    {modeType === 'view' ? 'View' : modeType === 'edit' ? "Edit" : 'Add'} Template
                </DialogTitle>
                <DialogContent dividers={true}>
                    <Grid container spacing={1}>
                        <Grid item md={4} sm={6} xs={12}>
                            <Autocomplete
                                id="engine_family"
                                disabled={modeType === 'view'}
                                options={egineFamily || []}
                                getOptionLabel={(option) => option?.name}
                                value={data?.engine_family || null}
                                margin='normal'
                                onChange={(e, value) => { onFieldChange("engine_family", value); setError({ ['engine_family']: '' }) }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        required
                                        label="Engine Family"
                                        margin='normal'
                                        placeholder="Select engine family"
                                        variant="outlined"
                                        fullWidth
                                        error={error.engine_family ? true : false}
                                        helperText={error.engine_family ? error.engine_family : ''}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{
                                            ...params.inputProps,
                                            readOnly: !!data?.engine_family, // Makes input read-only when a value exists
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={4} sm={6} xs={12}>
                            <Autocomplete
                                id="section_id"
                                disabled={modeType === 'view'}
                                options={[{ id: 4, name: 'AD STATUS' }, { id: 5, name: 'SB STATUS' }, { id: 8, name: 'LLP STATUS' }, { id: 10, name: 'INVENTORY LIST' }, { id: 12, name: 'SOFT TIME' }, { id: 16, name: 'MASTER COMPONENTS' }] || []}
                                getOptionLabel={(option) => option?.name}
                                value={data?.section_id || null}
                                margin='normal'
                                onChange={(e, value) => { onFieldChange("section_id", value); setError({ ['section_id']: '' }) }}
                                renderInput={(params) => (
                                    <TextField
                                        required
                                        {...params}
                                        label="Section"
                                        margin='normal'
                                        placeholder="Select section"
                                        variant="outlined"
                                        fullWidth
                                        error={error.section_id ? true : false}
                                        helperText={error.section_id ? error.section_id : ''}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{
                                            ...params.inputProps,
                                            readOnly: !!data?.section_id, // Makes input read-only when a value exists
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={4} sm={6} xs={12}>
                            <Autocomplete
                                id="active"
                                disabled={modeType === 'view'}
                                options={[{ id: true, name: "YES" }, { id: false, name: "NO" }]}
                                getOptionLabel={(option) => option?.name}
                                // value={data?.active ? "YES" : "NO" || null}
                                value={[{ id: true, name: "YES" }, { id: false, name: "NO" }].filter(item => item?.id === data?.active)[0] || null}
                                margin='normal'
                                onChange={(e, value) => onFieldChange("active", value ? value?.id : value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        disabled={modeType === 'view'}
                                        label="Active"
                                        margin='normal'
                                        placeholder="Select active"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{
                                            ...params.inputProps,
                                            readOnly: !!data?.active, // Makes input read-only when a value exists
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={12} sm={6} xs={12}>
                            <TextField
                                disabled={modeType === 'view'}
                                name="remarks"
                                label="Remarks"
                                fullWidth
                                multiline
                                rows={3}
                                margin="normal"
                                value={data?.remarks || ''}
                                onChange={(e, value) => onFieldChange('remarks', e.target.value)}
                                inputProps={{ maxLength: 250 }}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={12} sm={12} xs={12}>
                            {data?.file?.length ? null : data?.id && tempData?.file_path ?
                                <>
                                    <Button onClick={() => handleChipClick(tempData?.file_name, data?.id)} style={{ margin: '4px' }} size='small' variant='outlined' color='primary' >{tempData?.file_name}</Button>
                                   {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) ?  <Tooltip title="Remove" placement='top' arrow>
                                        <span style={{ verticalAlign: "middle", cursor: 'pointer' }}><CloseIcon onClick={() => setDeleteTempFile({ modal: true, data: tempData })} color='secondary' /></span>
                                    </Tooltip>:null}
                                </>
                                : null
                            }
                            {modeType !== 'view' ?
                                <>
                                    <div>
                                        {data?.engine_family?.name && data?.section_id?.id ? <label style={{ display: 'inline-flex', alignItems: 'center' }} >Refer the sample template
                                            <span className='download-sample-temp' onClick={() => templateDownload()} > DOWNLOAD  <ArrowDropDownIcon fontSize='small'/></span>
                                        </label> : null}
                                        <DropzoneArea
                                            acceptedFiles={['.xlsx']}
                                            filesLimit={1}
                                            maxFileSize={104857600}
                                            showPreviewsInDropzone={false}
                                            useChipsForPreview={true}
                                            showPreviews={true}
                                            dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop<br /> OR <br /> Click Here<br /> </p>}
                                            dropzoneClass="drag-drop-cnt"
                                            maxWidth="sm"
                                            showAlerts={['info', 'error']}
                                            alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                            clearOnUnmount={true}
                                            onChange={(files) => onFieldChange('file', files)}
                                            previewChipProps={{
                                                onClick: (event) => {
                                                    handleChipClick(event?.target.textContent);
                                                }
                                            }}
                                        />
                                    </div>
                                    <span style={{ fontSize: '11px' }} className='files-upload-limit' > Note : Max file upload limit is 1 in single time, with supported extension ('.xlsx').</span>
                                </> : null
                            }
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} color="primary" variant="outlined" onClick={() => { modalCloseFn() }}>CLOSE</Button>
                    {modeType === 'view' ? null : <Button disabled={isLoading} color="primary" variant="contained" onClick={() => { onAddEditTemp() }}> SAVE </Button>}
                </DialogActions>
            </Dialog>
            {
                previewFile?.modal ?
                    <Dialog
                        open={previewFile?.modal}
                        onClose={() => setPreviewFile({ modal: false, data: null })}
                        style={{ height: "100vh" }}
                        fullWidth
                        maxWidth="lg"
                        className='template-preview'
                    >
                        <DialogTitle>
                            Template Preview
                        </DialogTitle>
                        <DialogContent dividers>
                            {previewFile?.mode ?
                                <div>
                                    <iframe src={'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(data?.file_path)} width='100%' height={window.innerHeight} frameborder='0'></iframe>
                                </div>
                                :
                                previewFile?.data?.file_name?.endsWith('.xlsx') ?
                                    <div>
                                        <iframe src={'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(previewFile?.data?.file_url)} width='100%' height={window.innerHeight} frameborder='0'></iframe>
                                    </div> : null
                            }
                        </DialogContent>
                        <DialogActions>
                            <Button color="primary" size='small' variant="outlined" onClick={() => setPreviewFile({ modal: false, data: null })}>CLOSE</Button>
                        </DialogActions>
                    </Dialog> : null
            }
            {
                isLoading ? <PageLoader /> : null
            }
            {
                deleteTempFile?.modal ?
                    <DeletePopUp
                        title='Delete Template File'
                        deleteRecordFn={() => deleteTemplateFile()}
                        modal={true}
                        content={`Do you really want to delete this file`}
                        toggleModalFn={() => setDeleteTempFile({ modal: false, data: null })}
                    />
                    : null
            }

        </>
    )
}
export default TemplateCRU;